import axios, { type CreateAxiosDefaults } from 'axios';
import { env } from '../config/env';
import { HTTP_HEADERS } from './constants';
import { installInterceptors } from './interceptors';

declare module 'axios' {
  interface AxiosRequestConfig {
    /** Don't attach a Bearer token and don't run the 401 refresh (public endpoints). */
    skipAuth?: boolean;
    /** Internal: set by the 401 handler so a request is retried at most once. */
    _retry?: boolean;
  }
}

/** Builds a configured client. Exported for tests; app code uses `apiClient` through `http.ts`. */
export const createApiClient = (overrides: CreateAxiosDefaults = {}) => {
  const client = axios.create({
    baseURL: env.apiBaseUrl,
    timeout: env.apiTimeoutMs,
    headers: {
      [HTTP_HEADERS.accept]: 'application/json',
      [HTTP_HEADERS.origin]: env.originStrategy,
    },
    // `{ status: ['a', 'b'] }` → `?status=a&status=b`, which is what ASP.NET model binding expects.
    paramsSerializer: { indexes: null },
    ...overrides,
  });
  installInterceptors(client);
  return client;
};

/**
 * The single axios instance for the CMPS API. Only `src/shared/api` may import axios (ESLint);
 * modules call `request` / `http` from `./http`.
 */
export const apiClient = createApiClient();
